//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from "moment";
// import BackendServices from "@/services/backend-services";
import { required } from "@/utils/validations.js";
import { noValidation } from "@/utils/validations.js";

export default {
  name: "GeographyTab",
  props: ["value", "refData", "create"],
  mounted: function() {
    // this.validateData();
  },
  data: function() {
    return {
      moment,
      validForm: false,
      hierarchyLevels: [],
      hierarchyLevelElements: [],
      aggregatorList: this.create ? [{id: null, name: "Sem Agregador"}].concat(this.refData) : [{id: null, name: "Sem Agregador"}].concat(this.refData).filter(e => e.id != this.value.id)
    };
  },
  methods: {
    required,
    noValidation,
    validateData: function() {
      this.$refs.form.validate().then(success => {
        if (success) {
          this.validForm = true;
          this.$emit("form-valid", this.validForm);
        } else {
          this.validForm = false;
          this.$emit("form-invalid", this.validForm);
        }
      });
    },
    updateData() {
      if (this.value.classificationLevel > 1) {
        this.value.classificationAgregatorLevel = this.hierarchyLevels[
          this.value.classificationLevel - 2
        ].name;
      }

      this.$emit("value", this.value);
    },
    calcDepth(id, data) {
      const element = data[data.map((i) => (i.id)).indexOf(id)];
      if(element.parent_id === null) {
        return 1;
      } else {
        return 1 + this.calcDepth(element.parent_id, data);
      }
    }
  },
  watch: {
    value: {
      handler() {
        this.aggregatorList = this.create ? [{id: null, name: "Sem Agregador"}].concat(this.refData) : [{id: null, name: "Sem Agregador"}].concat(this.refData).filter(e => e.id != this.value.id)
      },
      deep: true
    }
  }
}
